module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.a613e81.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Bold.otf
// module id = yYff
// module chunks = 0